import { render, staticRenderFns } from "./HealthAssessment.vue?vue&type=template&id=4cc59daa&scoped=true&"
import script from "./HealthAssessment.vue?vue&type=script&lang=js&"
export * from "./HealthAssessment.vue?vue&type=script&lang=js&"
import style0 from "./HealthAssessment.vue?vue&type=style&index=0&id=4cc59daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc59daa",
  null
  
)

export default component.exports